import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { equals, clone } from 'ramda'
import { connect } from 'react-redux'
import { Checkbox as OriginalCheckbox, Select, Title2, TextInput, Button } from 'advenio-components'
import { Grid as OriginalGrid, Row as OriginalRow, Col as OriginalCol } from 'react-flexbox-grid'

export const FormContainer = styled.div`
  margin: 16px;
`
export const Grid = styled(props => (
  <OriginalGrid fluid {...props}>
    {props.children}
  </OriginalGrid>
))`
  padding-left: 0 !important;
  padding-right: 0 !important;
`
export const Row = styled(props => (
  <OriginalRow middle="xs" {...props}>
    {props.children}
  </OriginalRow>
))``
export const Col = styled(props => (
  <OriginalCol xs={12} {...props}>
    {props.children}
  </OriginalCol>
))``
export const Header = styled(Title2)``
const Checkbox = ({ label, name, value }) => (
  <OriginalCheckbox
    inputAlign
    invertedColors
    large
    hideEmptyHelpBlock
    label={label}
    name={name}
    value={value}
  />
)

Checkbox.propTypes = {
  /** The checkbox label text */
  label: PropTypes.string.isRequired,
  /** The checkbox name value */
  name: PropTypes.string.isRequired,
  /** The checkbox value */
  value: PropTypes.bool.isRequired,
}
class ParentProfileForm extends Component {
  state = {
    pays_automatically: null,
    requires_invoices: null,
    companies: [],
  }

  componentDidMount = () => {
    const { pays_automatically, requires_invoices } = this.props.info
    const { companies } = this.props

    const companies_ordered = clone(companies).sort((a, b) => {
      if (a.name > b.name) {
        return 1
      }

      if (a.name < b.name) {
        return -1
      }

      return 0
    })

    const companies_formatted = companies_ordered.map(item => ({
      label: item.name,
      value: item.id,
      id: item.id,
    }))

    companies_formatted.unshift({
      label: 'Sin empresa',
      value: 'sin_empresa',
      id: '',
    })

    this.setState({ pays_automatically, requires_invoices, companies: companies_formatted })
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (equals(this.props, nextProps) && equals(this.state, nextState)) return false

    return true
  }

  renderRelationsOptions = () => {
    const relationsClone = [...this.props.relations]

    return relationsClone.map(relation => ({
      id: relation.id,
      label: relation.translations.es,
      value: relation.id,
    }))
  }

  render() {
    const { info, showRelation, paymentAutomatic } = this.props
    const { companies } = this.state
    const optionRelations = this.renderRelationsOptions()
    return (
      <FormContainer>
        <Grid>
          <Row>
            <Col sm={6} md={3}>
              <TextInput
                name="first_name"
                label="Nombre(s)"
                value={info.first_name}
                required
              />
            </Col>
            <Col sm={6} md={3}>
              <TextInput
                name="last_name_paternal"
                label="Apellido Paterno"
                value={info.last_name_paternal}
                required
              />
            </Col>
            <Col sm={6} md={3}>
              <TextInput
                name="last_name_maternal"
                label="Apellido Materno"
                value={info.last_name_maternal}
              />
            </Col>
            <Col sm={6} md={3}>
              <TextInput
                name="nickname"
                label="Apodo"
                value={info.nickname}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={6} md={3}>
              <TextInput
                name="email"
                label="Correo Electrónico Personal"
                type="email"
                value={info.email}
                required
              />
            </Col>
            <Col sm={6} md={3}>
              <TextInput
                name="email_institutional"
                label="Correo Electrónico Institucional"
                type="email_institutional"
                value={info.email_institutional}
                disabled
              />
            </Col>
            <Col sm={6} md={3}>
              <TextInput
                name="contact_numbers.phone_number"
                label="Teléfono"
                value={info.contact_numbers ? info.contact_numbers.phone_number:''}
              />
            </Col>
            <Col sm={6} md={3}>
              <TextInput
                name="contact_numbers.cellphone_number"
                label="Celular"
                value={info.contact_numbers ? info.contact_numbers.cellphone_number:''}
              />
            </Col>
          </Row>
          <Row>
            {showRelation && (
              <Col sm={6} md={4}>
                <Select
                  name="relation_id"
                  label="Relación"
                  required
                  placeholder="Seleccione Relación"
                  value={info.relation_id}
                  options={optionRelations}
                  // emptyElement
                  // hideEmptyHelpBlock
                  fullWidth
                />
              </Col>
            )}
             {paymentAutomatic && (
              <Col sm={6} md={4}>
                <Checkbox
                  label="Requiere facturas"
                  name="requires_invoices"
                  value={info.requires_invoices}
                />
              </Col>
            )}
            {paymentAutomatic && (
              <Col sm={6} md={4}>
                <Checkbox
                  label="Pagos automáticos"
                  name="pays_automatically"
                  value={info.pays_automatically}
                />
              </Col>
            )}
          </Row>
          <Row>
            {!paymentAutomatic && (
              <Col sm={6} md={4}>
                <Checkbox
                  label="Requiere facturas"
                  name="requires_invoices"
                  value={info.requires_invoices}
                />
              </Col>
            )}
            <Col sm={paymentAutomatic ? 12 : 6} md={6}>
              <Select
                name="company_id"
                label="Empresa"
                placeholder="Seleccione empresa"
                // inline={false}
                // disabled={false}
                fullWidth
                value={info.company_id}
                // emptyElement
                // hideEmptyHelpBlock={false}
                // withGroup={false}
                options={companies}
              />
            </Col>
          </Row>
        </Grid>
      </FormContainer>
    )
  }
}

ParentProfileForm.propTypes = {
  /** An array with the parent's profile information */
  info: PropTypes.shape({
    /** Flag marking if the parent should be billed automatically each month */
    pays_automatically: PropTypes.bool.isRequired,
    /** Flag marking if the parent wishes to receive a copy of their invoices each month */
    requires_invoices: PropTypes.bool.isRequired,
    /** The ID of the parent's relation to the current student */
    relation_id: PropTypes.string,
    /** The parent's first name */
    first_name: PropTypes.string.isRequired,
    /** The parent's paternal last name */
    last_name_paternal: PropTypes.string.isRequired,
    /** The parent's maternal last name */
    last_name_maternal: PropTypes.string,
    /** The nickname used by the Center Admins to refer to the parent */
    nickname: PropTypes.string,
    /** The parent's email address */
    email: PropTypes.string.isRequired,
    /** The parent's contact phone numbers */
    contact_numbers: PropTypes.shape({
      /** The parent's primary telephone number */
      phone_number: PropTypes.string,
      /** The parent's cell phone number */
      cellphone_number: PropTypes.string,
    }),
    /** The parent's company */
    company_id: PropTypes.number,
  }),
  /** The listing of available family relations (Father, Uncle, Grandfather etc.) */
  relations: PropTypes.array.isRequired,
  /** Companies availables in Advenio */
  companies: PropTypes.array.isRequired,
}

ParentProfileForm.defaultProps = {
  info: {
    relation_id: null,
    last_name_maternal: '',
    nickname: '',
    contact_numbers: {
      phone_number: '',
      cellphone_number: '',
    },
    company_id: null,
    pays_automatically: false,
    requires_invoices: false,
  },
  showRelation: true,
  paymentAutomatic: true
}

const mapStateToProps = state => ({
  relations: state.relations.get.results,
  companies: state.companies.get.results,
})

const mapDispatchToProps = () => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(ParentProfileForm)



// WEBPACK FOOTER //
// ./src/Components/ParentComponents/ParentProfileForm.jsx